import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';

export interface ExternalLinkConfig {
  withLogin?: boolean;
  redirect?: string;
  queryParams?: Record<string, string>;
}

export interface ExternalLink {
  url: string;
  target: string;
}

export interface LinksServiceConfig {
  dadAppUrl: string;
  managementAppUrl: string;
  papAppUrl: string;
  teacherAppUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class LinksService {
  private readonly authService = inject(AuthService);

  private config: LinksServiceConfig | null = null;

  readonly globalTarget = '_self';

  setConfig(newConfig: LinksServiceConfig | null) {
    this.config = newConfig;
  }

  getDadAppUrl(config?: ExternalLinkConfig): ExternalLink {
    return {
      url: this.constructUrl(this.config?.dadAppUrl || '', config),
      target: 'dadApp',
    };
  }

  getManagementAppUrl(config?: ExternalLinkConfig): ExternalLink {
    return {
      url: this.constructUrl(this.config?.managementAppUrl || '', config),
      target: this.globalTarget,
    };
  }

  getPapAppUrl(config?: ExternalLinkConfig): ExternalLink {
    return {
      url: this.constructUrl(this.config?.papAppUrl || '', config),
      target: this.globalTarget,
    };
  }

  getTeacherAppUrl(config?: ExternalLinkConfig): ExternalLink {
    return {
      url: this.constructUrl(this.config?.teacherAppUrl || '', config),
      target: this.globalTarget,
    };
  }

  mockAppUrl(url: string): ExternalLink {
    return {
      url: url,
      target: '_blank',
    };
  }

  // TOOD better implementation
  private constructUrl(targetLink: string, config?: ExternalLinkConfig): string {
    let url = targetLink;

    const withLogin = !config || !Object.prototype.hasOwnProperty.call(config, 'withLogin') || config?.withLogin;

    if (withLogin) {
      url += `/login/external?token=${this.authService.accessToken}`;
    }

    if (config?.redirect) {
      if (!withLogin) {
        url += config.redirect;
      } else {
        url += `&redirect=${config.redirect}`;
      }
    }

    if (config?.queryParams) {
      Object.entries(config.queryParams).forEach(([key, value]) => {
        url += `&${key}=${value}`;
      });
    }
    return url;
  }
}
